import React from "react";
import { cn } from "utils";
import { useMarketStatus } from "@/src/hooks/useMarketStatus";
import { useStartObserveHeight } from "@/src/mobiles/mainContainer/HeightRecorderContext";
import type { StockType } from "@/src/utils/stockType";

/**
 * 市场状态组件属性
 */
export interface MarketStatusProps {
  /** 股票市场类型（US | HK）
   * @note 优先使用传入的值，如果没有传入则从路由 pathname 解析
   */
  stockType?: StockType;
  /** 自定义类名 */
  className?: string;
}

/**
 * 市场状态组件
 * 显示当前市场状态（盘前/盘中/盘后/休市等）和当前时间
 */
export const MarketStatus: React.FC<MarketStatusProps> = ({
  stockType,
  className,
}) => {
  const { formattedTime, statusText, isLoading } = useMarketStatus({
    stockType,
  });
  useStartObserveHeight(isLoading, !!statusText || !!formattedTime);
  if (isLoading) {
    return null;
  }

  return (
    <div className={cn("px-4 pt-0 pb-0", className)}>
      <span className="body_s text-content_quaternary">
        {`${statusText}: ${formattedTime}`}
      </span>
    </div>
  );
};
